import { Route } from 'react-router-dom';
import { InvestmentLeavePersonalInformation } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeavePersonalDetails/InvestmentLeavePersonalInformation/InvestmentLeavePersonalInformation';
import { InvestmentLeavePIVInformation } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeavePersonalDetails/InvestmentLeavePIVInformation/InvestmentLeavePIVInformation';
import { InvestmentLeaveBankAccount } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeavePersonalDetails/InvestmentLeaveBankAccount/InvestmentLeaveBankAccount';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { Box } from '@mantine/core';

export enum INVESTMENT_LEAVE_PERSONAL_DETAILS_ROUTES {
	PERSONAL_INFORMATION = '/personal-information',
	INVESTMENT_VEHICLE_INFORMATION = '/investment-vehicle-information',
	BANK_ACCOUNT = '/bank-account',
}

interface Props {
	setIsContinueDisabled: (isContinueDisabled: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
}

export const InvestmentLeavePersonalDetails = ({ setIsContinueDisabled, setIsLoading }: Props) => {
	return (
		<Box maw="40rem">
			<SentryRoutes>
				<Route
					path={INVESTMENT_LEAVE_PERSONAL_DETAILS_ROUTES.PERSONAL_INFORMATION}
					element={
						<InvestmentLeavePersonalInformation
							setIsContinueDisabled={setIsContinueDisabled}
							setIsLoading={setIsLoading}
						/>
					}
				/>
				<Route
					path={INVESTMENT_LEAVE_PERSONAL_DETAILS_ROUTES.INVESTMENT_VEHICLE_INFORMATION}
					element={
						<InvestmentLeavePIVInformation
							setIsContinueDisabled={setIsContinueDisabled}
							setIsLoading={setIsLoading}
						/>
					}
				/>
				<Route
					path={INVESTMENT_LEAVE_PERSONAL_DETAILS_ROUTES.BANK_ACCOUNT}
					element={<InvestmentLeaveBankAccount />}
				/>
			</SentryRoutes>
		</Box>
	);
};
